import React, { Component } from "react";
import DefaultErrorView from "presentational/error/DefaultErrorView";
import { withStore } from "store/storeHandler";
import PropTypes from "prop-types";

class ErrorCatcher extends Component {
  static propTypes = {
    isBackendServerBroken: PropTypes.bool.isRequired
  };

  componentDidCatch(error) {
    const { AppErrorActions } = this.props;
    AppErrorActions.setFatalAppError(error);
  }

  render() {
    const { isBackendServerBroken, children, needShutAppDown } = this.props;
    if (needShutAppDown) {
      return <DefaultErrorView />;
    } else if (isBackendServerBroken) {
      return <DefaultErrorView backendServerErrorType />;
    }
    return children;
  }
}

export default withStore({
  stateMap: { appError: ["needShutAppDown"] },
  dispatchMap: ["appError"]
})(ErrorCatcher);
